import React from 'react';
export const DataTabIcon = (props: any) => {
  return (
    <svg {...props} className="svg-icon">
      <svg id="icon-data" viewBox="0 0 1075 1024">
        <title>Data</title>
        <path
          className="path1"
          d="M695.417 444.359c0-37.356 30.281-67.641 67.641-67.641s67.641 30.285 67.641 67.641c0 37.356-30.281 67.641-67.641 67.641s-67.641-30.285-67.641-67.641zM469.947 444.359c0-37.356 30.281-67.641 67.641-67.641s67.641 30.285 67.641 67.641c0 37.356-30.281 67.641-67.641 67.641s-67.641-30.285-67.641-67.641zM244.478 444.359c0-37.356 30.281-67.641 67.641-67.641s67.641 30.285 67.641 67.641c0 37.356-30.281 67.641-67.641 67.641s-67.641-30.285-67.641-67.641zM109.197 61.062c-24.901 0-45.093 20.189-45.093 45.093v676.407c0 24.906 20.194 45.093 45.093 45.093h293.11l135.281 135.281 135.281-135.281h293.11c24.901 0 45.093-20.189 45.093-45.093v-676.407c0-24.906-20.194-45.093-45.093-45.093h-856.782z"
        ></path>
      </svg>
    </svg>
  );
};
